import type { MigrationStrategies } from "./_types/migration-strategies";

// v0 → v1: `id` maxLength widened from 200 to 250 to leave headroom over the
// `userId` + `categoryKey` composite key. Existing rows pass the new constraint.
export const NOTIFICATION_PREFERENCE_MIGRATION_STRATEGIES: MigrationStrategies =
  {
    1: (oldDoc) => oldDoc,
  };
